/**
 * Defer ResizeObserver callbacks to the next animation frame.
 *
 * "ResizeObserver loop completed with undelivered notifications" fires when a
 * callback synchronously mutates layout (recharts ResponsiveContainer setState,
 * Sentry replay), re-triggering observation inside the same delivery frame.
 * Deferring via requestAnimationFrame breaks that cycle. Notifications are
 * delivered one frame later — no data loss, no behavioral change.
 */
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch {
            // observed element unmounted during deferral — safe to drop
          }
        });
      });
    }
  };
}
